import { unFormatCurrency, unFormatUnknownUnit } from "@/common/utils/unFormatters"
import { CardProductLimitValidationSchema } from "../schemas/create.schema";

export const transformNewApplicableProducts = (applicableProduct: CardProductLimitValidationSchema) => ({
  product_id: applicableProduct.product_id,
  quantity_limit_per_transaction:
    applicableProduct.limitByTransaction
      ? ((applicableProduct.transactionLimit?.quantity && unFormatUnknownUnit(applicableProduct.transactionLimit?.quantity) > 0)
        ? unFormatUnknownUnit(applicableProduct.transactionLimit?.quantity)
        : null)
      : null,
  credit_limit_per_transaction:
    applicableProduct.limitByTransaction
      ? ((applicableProduct.limitByTransaction && applicableProduct.transactionLimit?.totalValue)
        ? unFormatCurrency(applicableProduct.transactionLimit?.totalValue)
        : null)
      : null,
  period_in_days: applicableProduct.limitByPeriod ? applicableProduct.periodLimit?.period?.value : undefined,
  quantity_limit_per_period:
    applicableProduct.limitByPeriod
      ? (applicableProduct.periodLimit?.quantity && unFormatUnknownUnit(applicableProduct.periodLimit?.quantity) > 0)
        ? unFormatUnknownUnit(applicableProduct.periodLimit?.quantity)
        : null
      : null,
  credit_limit_per_period:
    applicableProduct.limitByPeriod
      ? ((applicableProduct.limitByPeriod && applicableProduct.periodLimit?.totalValue)
        ? unFormatCurrency(applicableProduct.periodLimit?.totalValue)
        : null)
      : null,
})

export const transformUpdatedApplicableProducts = (applicableProduct: CardProductLimitValidationSchema) => {
  return {
    ...transformNewApplicableProducts(applicableProduct),
    product_id: undefined,
    id: applicableProduct.id,
  }
}
